import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // On every route change (including initial load), scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

    // On app mount, disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // Also scroll to top on initial load (in case the browser still tries)
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollToTop;
